// 코드관리(SY07) 화면 상수 — 화면(index.tsx) 배선이 쓰는 문구·계정 판정. UI(컬럼·필터)는 컨덕터 생성본이 정본이라 여기 두지 않는다.

/** 목록 구간 크기 = BE size 상한 — Pageable 기본 max-page-size(2000, moms-be 설정 없음). 넘겨 보내면 오류 없이 2000건으로 잘린다(LOGISPRD-15271). */
export const SY07_FETCH_CHUNK_SIZE = 2000

export const MESSAGES = {
  noShipper: '화주명을 선택해 주세요.',
  noSelection: '저장할 행을 선택해 주세요.',
  requiredCells: '화주코드·코드그룹·코드·코드내용은 필수입니다.',
  shipperLocked: '다른 화주의 코드는 저장할 수 없습니다.',
  deleteShipperLocked: '다른 화주의 코드는 삭제할 수 없습니다.',
  shipperLoadFailed: '화주 목록을 불러오지 못했습니다. 새로고침한 뒤 다시 시도해 주세요.',
  /** 행별 순차 처리 중 실패 — 실패 지점에서 멈추므로 앞의 done 건은 이미 반영됐다. */
  partialFailed: (total: number, done: number, reason: string) => `${total}건 중 ${done}건 반영 후 실패했습니다. ${reason}`,
} as const
